"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GlobalCtx_1 = __importDefault(require("./GlobalCtx"));
const MyEvent_1 = __importDefault(require("./MyEvent"));
class AudioInstance {
    constructor(source) {
        this._playing = false;
        /**
         * when sound is playing, keep it valid to (now - starttime) * playbackrate == position
         * when not playing, it's not valid at all
         */
        this._starttime = 0;
        /**
         * when sound is playing, it's not valid at all
         * when not playing, it shows where to start sound
         */
        this._startpos = 0;
        this._playbackrate = 1;
        this.onplay = new MyEvent_1.default();
        this.onpause = new MyEvent_1.default();
        this.onseek = new MyEvent_1.default();
        this.onend = new MyEvent_1.default();
        /**
         * set startpos before calling it
         */
        this.callstart = (delay) => {
            const startt = GlobalCtx_1.default.now + delay;
            this.node.start(startt, this._startpos);
            const playedtime = this._startpos / this._playbackrate;
            this._starttime = startt - playedtime;
            this._playing = true;
        };
        this.handleNormalEnd = () => {
            this._startpos = 0;
            this._playing = false;
            this.node = this.createnode();
            this.onend.dispatch();
        };
        this.handlePauseEnd = () => {
            this._startpos = this.position; // get before _playing is set to false
            this._playing = false;
            this.node = this.createnode();
            this.onpause.dispatch();
        };
        this.handleSeekEnd = () => {
            this.node = this.createnode();
            this.node.onended = this.handleNormalEnd;
            this.callstart(0);
            this.onseek.dispatch();
        };
        this.source = source;
        this.output = GlobalCtx_1.default.ctx.createGain();
        this.output.connect(source.destination);
        this.node = this.createnode();
    }
    get volume() {
        return Math.sqrt(this.output.gain.value);
    }
    set volume(v) {
        this.output.gain.value = v * v;
    }
    createnode() {
        const n = GlobalCtx_1.default.ctx.createBufferSource();
        n.buffer = this.source.buffer;
        n.connect(this.output);
        n.playbackRate.value = this._playbackrate;
        return n;
    }
    get playing() {
        return this._playing;
    }
    get position() {
        if (!this._playing)
            return this._startpos;
        const now = GlobalCtx_1.default.now;
        const playedtime = now - this._starttime;
        // if (this._playbackrate !== 1) return playedtime * this._playbackrate - 0.016
        return playedtime * this._playbackrate;
    }
    play(delay = 0) {
        if (this._playing)
            return this;
        this.callstart(delay);
        // normal end
        this.node.onended = this.handleNormalEnd;
        this.onplay.dispatch();
        return this;
    }
    stop(delay = 0) {
        if (!this._playing) {
            this._startpos = 0;
            return this;
        }
        // normal end, maybe we have to override pause end handler
        this.node.onended = this.handleNormalEnd;
        this.node.stop(GlobalCtx_1.default.now + delay);
        return this;
    }
    pause(delay = 0) {
        if (!this._playing)
            return this;
        // pause caused end
        this.node.onended = this.handlePauseEnd;
        this.node.stop(GlobalCtx_1.default.now + delay);
        return this;
    }
    seek(position) {
        position = Math.max(0, Math.min(this.source.duration, position));
        if (!this._playing) {
            this._startpos = position;
            this.onseek.dispatch();
            return this;
        }
        this._startpos = position;
        const playedtime = this._startpos / this._playbackrate;
        this._starttime = GlobalCtx_1.default.now - playedtime;
        // seek caused end
        this.node.onended = this.handleSeekEnd;
        this.node.stop(GlobalCtx_1.default.now);
        return this;
    }
    get rate() {
        return this._playbackrate;
    }
    setRate(rate) {
        rate = Math.max(0.25, Math.min(4, rate));
        const currentpos = this.position; // get currentpos before set playbackrate
        this._playbackrate = rate;
        this.node.playbackRate.value = this._playbackrate;
        if (this._playing) {
            const now = GlobalCtx_1.default.now;
            const playedtime = currentpos / rate;
            this._starttime = now - playedtime;
        }
        return this;
    }
}
exports.default = AudioInstance;
//# sourceMappingURL=AudioInstance.js.map